export default "__VITE_ASSET__CzrZYqS8__"